import axios from "axios"
import baseURL from "../configs/api"

export const getStatus = (attributeName: string, tenantId: string) => {
    return getFetch(`vendorStatus/GetVendorStatusesByAttributeName/${attributeName}`, tenantId);
}

const getFetch = (url: string, tenantId: string, params = {}) => {
    return axios({
        url: baseURL + url,
        method: "GET",
        headers: {
            'X-Tenant-ID': tenantId,
            "Content-Type": "application/json"
        },
        params: params
    }).then(response => response.data);
}